export const SETTINGS_UNITS_METRIC = 0
export const SETTINGS_UNITS_IMPERIAL = 1
